import type { FC, PointerEvent } from 'react';
import type { Block } from '@/components/canvas/blocks/types';
import type { BlockDisplayLayout } from '@/components/canvas/blocks/registry/types';
import { getBlockDefinition } from '@/components/canvas/blocks/registry/blockRegistry';

export type { BlockDisplayLayout };

export interface BlockViewRouterProps {
  block: Block;
  displayLayout: BlockDisplayLayout;
  onPointerDown?: (e: PointerEvent, block: Block) => void;
  isPresentationMode?: boolean;
}

/** 按 registry 渲染功能块视图 */
export const BlockView: FC<BlockViewRouterProps> = ({
  block,
  displayLayout,
  onPointerDown,
  isPresentationMode,
}) => {
  const def = getBlockDefinition(block.type);
  if (!def) return null;
  const View = def.View;
  return (
    <View
      block={block as never}
      displayLayout={displayLayout}
      onPointerDown={onPointerDown as never}
      isPresentationMode={isPresentationMode}
    />
  );
};
